import { render, staticRenderFns } from "./EmptyPageView.vue?vue&type=template&id=b768e18c&"
import script from "./EmptyPageView.vue?vue&type=script&lang=js&"
export * from "./EmptyPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports